import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import getMasterMindLink from "../../../../common/helpers/getMasterminLink";
import { getVariantResult } from "../../../../state/selectors/general.selectors";
import HelperText from "../../../../components/atoms/HelperText";

const { shape } = PropTypes;

const MastermindLinks = (props) => {
  const { variant } = props;
  const masterminds = getMasterMindLink(variant, window.location.hostname, "");

  if (masterminds) {
    return masterminds.map((mm, i) => {
      let links = "";
      if (mm.identifiers.length > 0) {
        links = mm.identifiers.map((identifier, k) => {
          return (
            <div key={`${k}-link`}>
              <small>
                <a href={identifier.url} target="_blank">
                  <i className="fa fa-external-link" />
                  {" Mastermind"}
                </a>
                <HelperText fieldDescriptionKey="Mastermind" />
              </small>
            </div>
          );
        });
      }
      return <div key={i}>{links[0]}</div>;
    });
  }
  return null;
};

MastermindLinks.propTypes = {
  variant: shape({}),
};

MastermindLinks.defaultProps = {
  variant: "",
};

const mapStateToProps = (state) => ({
  variant: getVariantResult(state),
});

export default connect(mapStateToProps)(MastermindLinks);
